export function ready(fn: () => void) {
  // we need this workaround to support safari
  // https://developer.apple.com/forums/thread/651215?answerId=616455022#616455022
  if (document.readyState !== 'loading') {
    fn()
  } else {
    document.addEventListener('DOMContentLoaded', fn)
  }
}
